import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { AdminRevealScreen } from "../components/steps/AdminRevealScreen";
import { AdminWhoWillServeScreen } from "../components/steps/AdminWhoWillServeScreen";
import { AdminEligibilityScreen } from "../components/steps/AdminEligibilityScreen";
import { AdminCoApplyScreen } from "../components/steps/AdminCoApplyScreen";
import { AdminSomeoneElseScreen } from "../components/steps/AdminSomeoneElseScreen";

export function createConfirmAdminScreens(): FlowScreenConfig[] {
  return [
    {
      id: "admin_confirm_admin_reveal",
      layout: "full",
      customComponent: AdminRevealScreen,
      getButtonText: () => "Continue",
    },
    {
      id: "admin_confirm_admin_who_will_serve",
      layout: "full",
      customComponent: AdminWhoWillServeScreen,
      validate: (answers) => {
        const errors: Record<string, string> = {};
        if (!answers["admin_confirm_admin_mode"]) {
          errors.admin_mode = "Select an option to continue";
        }
        return errors;
      },
    },
    {
      id: "admin_confirm_admin_eligibility",
      layout: "full",
      customComponent: AdminEligibilityScreen,
      shouldDisplay: ({ answers }) => {
        const mode = answers["admin_confirm_admin_mode"];
        return mode === "sole" || mode === "co";
      },
      validate: (answers) => {
        const errors: Record<string, string> = {};
        if (answers["admin_eligibility_age"] !== "yes") errors.eligibility = "All checkboxes are required";
        if (answers["admin_eligibility_citizen"] !== "yes") errors.eligibility = "All checkboxes are required";
        if (answers["admin_eligibility_felony"] !== "yes") errors.eligibility = "All checkboxes are required";
        return errors;
      },
    },
    {
      id: "admin_confirm_admin_co_apply",
      layout: "full",
      customComponent: AdminCoApplyScreen,
      shouldDisplay: ({ answers }) => answers["admin_confirm_admin_mode"] === "co",
      validate: (answers) => {
        const errors: Record<string, string> = {};
        const raw = answers["admin_confirm_admin_co_applicants"];
        if (typeof raw !== "string" || !raw) {
          errors.co_applicants = "Select at least one co-applicant";
          return errors;
        }
        try {
          const ids = JSON.parse(raw) as number[];
          if (ids.length === 0) errors.co_applicants = "Select at least one co-applicant";
        } catch {
          errors.co_applicants = "Select at least one co-applicant";
        }
        return errors;
      },
    },
    {
      id: "admin_confirm_admin_someone_else",
      layout: "full",
      customComponent: AdminSomeoneElseScreen,
      shouldDisplay: ({ answers }) => answers["admin_confirm_admin_mode"] === "someone_else",
      validate: (answers) => {
        const errors: Record<string, string> = {};
        if (!answers["admin_someone_else_full_name"]) errors.someone_full_name = "Full name is required";
        if (!answers["admin_someone_else_relationship"]) errors.someone_relationship = "Relationship is required";
        const email = answers["admin_someone_else_email"];
        if (!email) {
          errors.someone_email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email))) {
          errors.someone_email = "Enter a valid email address";
        }
        return errors;
      },
      getButtonText: () => "Send invite",
    },
  ];
}
